import React from 'react';
import MainImg from '../mainImage.jpg'
import { makeStyles } from '@mui/styles';
import typeText from './data/Home.json';
import { TypeAnimation } from 'react-type-animation';

const useStyles = makeStyles(() => ({
  mainImage: {
    width: "100%",
    height: "800px",
    objectFit: 'cover',
    backgroundImage: `url(${MainImg})`,
    backgroundSize: "cover",
    backgroundPosition: "50%",
    overflow: "hidden",
    "@media (max-width: 900px)": {
      height: "350px",
    },
  },
  homeDiv: {
    width: "100%",
    height: "100%",
  },
  MainMessage: {
    margin: "0",
    fontFamily: 'Noto Serif, serif',
    fontSize: '50px',
    color: 'white',
    position: 'relative',
    top: '25%',
    left: '10%',
    "@media (max-width: 900px)": {
      top: '5%',
      left: '5%',
      fontSize: '30px',
      paddingLeft: 0,
    },
  },
  SubMessage: {
    margin: "0",
    fontFamily: 'Noto Serif, serif',
    fontSize: '50px',
    color: 'white',
    position: 'relative',
    top: '25%',
    left: '30%',
    "@media (max-width: 1300px)": {
      top: '25%',
      left: '35%',
      fontSize: '30px',
      paddingLeft: 0,
    },
    "@media (max-width: 900px)": {
      top: '10%',
      left: '5%',
      fontSize: '30px',
      paddingLeft: 0,
    },
  },

}));

const Home = () => {
    const {mainImage, homeDiv, MainMessage, SubMessage} = useStyles();
    return (
      <section className={mainImage} id='homeSection' >
        <div className={homeDiv}>
          <h1 className={MainMessage}>
            <TypeAnimation
              sequence={[typeText.mainText[0]]}
              speed={50}
              cursor={false}
            />
          </h1>
          <h3 className={SubMessage}>
            <TypeAnimation
              sequence={[4000, typeText.subText[0]]}
              speed={50}
              cursor={false}
            />
          </h3>
        </div>
      </section>
    );
};

export default Home;
